/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/doug-shelf-talker-post-card-content/doug-shelf-talker-post-card-content.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=doug-shelf-talker-post-card-content.component.css.map */
